import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { apis } from '../api/index.js';
import './preview.css';
import { Button, Icon } from 'antd';
import printLogo from '../imgs/print-logo.png';
import hujulin from '../imgs/hujulin.png';
import ReactToPrint from 'react-to-print';
import ConnectedPrintReport from './ConnectedPrintReport.js';
import qs from 'query-string';
import { getSex, formatDA } from '../utils';

class PreviewReport extends Component {
  static propTypes = {
    server: PropTypes.object,
    match: PropTypes.object,
  };

  constructor(props) {
    super(props);
    const roleInfo = window.store.getState().api.user.info.operationAuths || '';
    const isAnonymity = roleInfo.indexOf('S') >= 0;
    this.state = {
      dicomId: props.match.params.dicomId,
      uploadType: props.match.params.uploadType,
      report: '',
      token: qs.parse(window.location.search).token,
      readyToPrint: false,
      readyImgLen: 0,
      imgsHtml: [],
      isAnonymity,
    };
  }

  static propTypes = {
    history: PropTypes.object,
  };

  componentDidMount() {
    this.getReport();
  }

  getReport = () => {
    const { dicomId, uploadType, token } = this.state;
    if (!dicomId || !uploadType) return;
    const template = Promise.resolve(
      apis.getTemplateReport4Study(dicomId, uploadType, token)
    );
    const post = { id: dicomId, type: uploadType };
    const detail = Promise.resolve(apis.detailList4Study(post));
    Promise.all([template, detail]).then(values => {
      const result = values[0].data;
      result.imgList = values[1].data;
      this.setState({ report: result });
      this.getImgs(values[1].data);
    });
  };

  close = () => {
    window.close();
  };

  setDoctorReviewStatus = () => {
    const { dicomId } = this.state;
    apis.setDoctorReviewStatus4Study(dicomId, '3');
  };

  //根据token获取图像
  getImageWithToken = (url, id, len) => {
    const _this = this;
    let xmlhttp;
    xmlhttp = new XMLHttpRequest();
    xmlhttp.open('GET', url, true);
    xmlhttp.responseType = 'blob';
    const token = window.localStorage.getItem('access_token');
    xmlhttp.setRequestHeader('Authorization', 'Bearer ' + token); //该处加上你当前的token
    xmlhttp.onload = function() {
      if (xmlhttp.status === 200) {
        let blob = this.response;
        let img = document.createElement('img');
        const canvas = document.createElement('canvas');
        img.onload = function(e) {
          let { readyImgLen } = _this.state;
          window.URL.revokeObjectURL(img.src);

          let height = 0;
          if (len <= 2) height = 250;
          else height = 170;
          const width = parseInt(img.width / (img.height / height));
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx.clearRect(0, 0, width, height);
          ctx.drawImage(img, 0, 0, width, height);

          readyImgLen++;
          _this.setState({ readyImgLen });
          if (readyImgLen === len) _this.setState({ readyToPrint: true });
        };
        img.setAttribute('class', 'image-view');
        img.src = window.URL.createObjectURL(blob);
        var el = document.getElementById(id);
        var childs = el.childNodes;
        for (var i = childs.length - 1; i >= 0; i--) {
          el.removeChild(childs[i]);
        }
        el.appendChild(canvas);
      }
    };
    xmlhttp.send(null);
  };

  getImgs = (imgList = []) => {
    const len = imgList.length;
    if (len <= 0) return;
    const html = [];
    imgList.forEach((item, index) => {
      let url = `/v1/picl/aets/piclarc/rs/studies/${item.studyUid}/series/${item.seriesUid}/instances/${item.sopInstanceId}/frames/1/rendered`;
      html.push(
        <span id={`preview-img${index}`} key={index}>
          {this.getImageWithToken(url, `preview-img${index}`, len)}
        </span>
      );
    });
    this.setState({ imgsHtml: html });
  };

  render() {
    const { report, isAnonymity } = this.state;
    if (report) {
      return (
        <>
          <div className="preview-report preview-report-margin">
            <div className="title">
              {report.record.institutionId === 107 ? (
                <>
                  <p className="title-1">江西省胸科医院肺结核AI筛查报告</p>
                  <p className="title-2">-九峰医疗提供技术支持</p>
                </>
              ) : (
                <>
                  <p className="title-1">{report.record.institutionName}</p>
                  <p className="title-2">肺结核筛查报告</p>
                </>
              )}
            </div>
            <div className="institution">
              <p>送检机构：{report.record.institutionName}</p>
              <p>检查日期：{formatDA(report.record.createTime)}</p>
            </div>
            <div className="user-info">
              <span>姓名：{isAnonymity ? '***' : report.record.patName}</span>
              <span>性别：{getSex(report.record.patSex)}</span>
              <span>年龄：{report.record.patAge}</span>
            </div>
            <div className="user-info">
              <span>影像号：</span>
              <span>就诊卡号：</span>
              <span>住院号：</span>
            </div>
            <div className="user-info">
              <span>床位号：</span>
              <span>检查号：</span>
              <span></span>
            </div>
            <div className="preview-img" id="previewImg">
              {this.state.imgsHtml}
            </div>
            <div className="preview-content">
              <p className="title">影像所见</p>
              <div className="content"></div>
            </div>
            <div className="preview-content">
              <p className="title">AI辅助诊断参考意见</p>
              <div className="content">{report.templateReport}</div>
            </div>
            <div className="preview-content">
              <p className="title">诊断建议</p>
              <div className="content">
                <p>{report.doctorVerifyCodeToText}</p>
                <p>{report.doctorRemark}</p>
              </div>
            </div>
            <div className="printer-footer">
              {report.record.institutionId === 107 ? (
                <>
                  <div className="printer-review">
                    审核医生：
                    <img className="print-name" alt="" src={hujulin} />
                    <span>审核时间：{report.record.updateTime}</span>
                  </div>
                  <div className="printer-tip">
                    注：此报告仅对上述检查项目提供诊断信息，仅供临床医生诊断参考，不作其它用途。
                  </div>
                </>
              ) : (
                <div>
                  <img className="print-logo" alt="" src={printLogo} />
                  <span className="print-time">
                    打印日期：{formatDA(new Date())}
                  </span>
                </div>
              )}
            </div>
          </div>
          <div className="print-btns">
            <Button className="btn-print-close" onClick={this.close}>
              <Icon type="eye-invisible" theme="filled" />
              关闭预览
            </Button>
            <ReactToPrint
              trigger={() => (
                <Button
                  className="btn-print-do"
                  disabled={!this.state.readyToPrint}
                >
                  <Icon type="printer" theme="filled" />
                  打印报告
                </Button>
              )}
              content={() => this.componentRef}
              onAfterPrint={() => {
                this.setDoctorReviewStatus();
              }}
            />
          </div>
          <div style={{ display: 'none' }}>
            <div ref={el => (this.componentRef = el)}>
              <ConnectedPrintReport
                report={this.state.report}
                printDicomId={this.state.dicomId}
              />
            </div>
          </div>
        </>
      );
    } else {
      return null;
    }
  }
}

export default withRouter(PreviewReport);
